// /**
//  * JAVASCRIPT DEVELOPER DOCUMENTATION
//  *
//  * Canopy is a powerful and customizable theme designed for large-scale e-commerce stores. Built
//  * using Web Components, it offers a highly modular architecture that makes customization and
//  * maintenance easier than ever. In addition, Canopy is optimized for speed, ensuring that your
//  * store runs as fast as possible to provide your customers with a seamless shopping experience.
//  *
//  * If you would like to add your own JS to Canopy, we recommend using this file and referencing
//  * it using Theme Settings > Advanced > Custom HTML.
//  *
//  * As a brief overview, Canopy:
//  *  - Broadcasts many JS events.
//  *  - Is built using Web Components.
//  *  - Follows a 'code splitting' architecture.
//  *  - Is completely custom built (no JS libraries other than instant.page)
//  *  - Has a number of JS utilities.
//  *
//  *
//  *
//  * =================================================================================================
//  * Custom JavaScript Events
//  * =================================================================================================
//  *
//  * Canopy broadcasts many custom events for ease of extensibility, detailed in this section.
//  *
//  * When in the Theme Editor, the details of each custom event will be logged out in the Dev Tools
//  * console everytime it is triggered.
//  *
//  * Events are named in the following convention: ["on/dispatch"]:[subject]:[action] (where
//  * 'dispatch' will trigger an event to occur, and 'on' indicates an event has occurred).
//  *
//  * All 'Return data' detailed in this section is returned within the 'event.detail' object.
//  *
//  * The available events are:
//  *  1.  on:variant:change
//  *  2.  on:cart:add
//  *  3.  on:cart:error
//  *  4.  on:line-item:change
//  *  5.  on:cart-drawer:before-open
//  *  6.  on:cart-drawer:after-open
//  *  7.  on:cart-drawer:after-close
//  *  8.  on:quickbuy:before-open
//  *  9.  on:quickbuy:after-open
//  *  10. on:quickbuy:after-close
//  *  11. dispatch:cart-drawer:open
//  *  12. dispatch:cart-drawer:refresh
//  *  13. dispatch:cart-drawer:close
//  *  14. on:debounced-resize
//  *  15. on:breakpoint-change
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 1) on:variant:change
//  * -------------------------------------------------------------------------------------------------
//  * Fires whenever a variant is selected (e.g. Product page, Quickbuy, Featured Product etc).
//  *
//  * How to listen:
//  * document.addEventListener('on:variant:change', (event) => {
//  *  // your code here
//  * });
//  *
//  * Returned data:
//  *  - form: the product form content
//  *  - variant: the selected variant object
//  *  - product: the product object (includes a list of all variants)
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 2) on:cart:add
//  * -------------------------------------------------------------------------------------------------
//  * Fires when a variant has been added to the cart, where it didn't exist in the cart before. This
//  * event does not fire when the added variant was already in the cart. To listen for this, see the
//  * on:line-item:change event.
//  *
//  * How to listen:
//  * document.addEventListener('on:cart:add', (event) => {
//  *   // your code here
//  * });
//  *
//  * Returned data:
//  *   - cart: the new cart object after the variant was added
//  *   - variantId: id of the variant that was just added to the cart
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 3) on:line-item:change
//  * -------------------------------------------------------------------------------------------------
//  * Fires when the quantity of an item already in the cart is updated. Note, if the 'newQuantity' is
//  * 0, this indicates the item was removed from that cart.
//  *
//  * Note, when adding a variant to the cart - this event will fire if that variant is already in the
//  * cart (i.e. the quantity is incremented). In this situation, 'on:cart:add' will not fire.
//  *
//  * How to listen:
//  * document.addEventListener('on:line-item:change', (event) => {
//  *   // your code here
//  * });
//  *
//  * Returned data:
//  *   - cart: the new cart object after the quantity change was completed
//  *   - variantId: id of the variant that was just updated
//  *   - newQuantity: new quantity of the line item
//  *   - oldQuantity: old quantity of the line item
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 4) on:cart:error
//  * -------------------------------------------------------------------------------------------------
//  * Fires when an action related to the cart has failed, for example adding too much quantity of an
//  * item to the cart.
//  *
//  * How to listen:
//  * document.addEventListener('on:cart:error', (event) => {
//  *   // your code here
//  * });
//  *
//  * Returned data:
//  *   - error: the error message
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 5) on:cart-drawer:before-open
//  * -------------------------------------------------------------------------------------------------
//  * Fires before the cart drawer opens.
//  *
//  * How to listen:
//  * document.addEventListener('on:cart-drawer:before-open', (event) => {
//  *   // your code here
//  * });
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 6) on:cart-drawer:after-open
//  * -------------------------------------------------------------------------------------------------
//  * Fires after the cart drawer has finished opening.
//  *
//  * How to listen:
//  * document.addEventListener('on:cart-drawer:after-open', (event) => {
//  *   // your code here
//  * });
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 7) on:cart-drawer:after-close
//  * -------------------------------------------------------------------------------------------------
//  * Fires after the cart drawer has finished closing.
//  *
//  * How to listen:
//  * document.addEventListener('on:cart-drawer:after-close', (event) => {
//  *   // your code here
//  * });
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 8) on:quickbuy:before-open
//  * -------------------------------------------------------------------------------------------------
//  * Fires before the quick buy drawer opens.
//  *
//  * How to listen:
//  * document.addEventListener('on:quickbuy:before-open', (event) => {
//  *   // your code here
//  * });
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 9) on:quickbuy:after-open
//  * -------------------------------------------------------------------------------------------------
//  * Fires after the quick buy drawer has finished opening.
//  *
//  * How to listen:
//  * document.addEventListener('on:quickbuy:after-open', (event) => {
//  *   // your code here
//  * });
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 10) on:quickbuy:after-close
//  * -------------------------------------------------------------------------------------------------
//  * Fires after the quick buy drawer has finished closing.
//  *
//  * How to listen:
//  * document.addEventListener('on:quickbuy:after-close', (event) => {
//  *   // your code here
//  * });
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 11) dispatch:cart-drawer:open
//  * -------------------------------------------------------------------------------------------------
//  * Opens the cart drawer (if enabled in the Theme Settings).
//  *
//  * How to trigger:
//  * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
//  *
//  * You can optionally pass in a 'detail' object with a property of 'opener', which specifies the DOM
//  * element that should be focussed on when the drawer is closed.
//  *
//  * Example:
//  * document.getElementById('header-search').addEventListener('keydown', (evt) => {
//  *   if (evt.keyCode === 67) {
//  *     evt.preventDefault();
//  *     document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
//  *       detail: {
//  *         opener: evt.target
//  *       }
//  *     }));
//  *   }
//  * });
//  *
//  * In this example, we attach a keydown listener to the search input in the header. If the user
//  * presses the 'c' key, it prevents the default behavior (which would be to type the letter 'c' in
//  * the input) and dispatches the 'dispatch:cart-drawer:open' event with a 'detail' object that
//  * specifies the search input as the opener. When the cart drawer is closed, focus is returned to
//  * the search input.
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 12) dispatch:cart-drawer:refresh
//  * -------------------------------------------------------------------------------------------------
//  * Refreshes the contents of the cart drawer.
//  *
//  * This event is useful when you are adding variants to the cart and would like to instruct the
//  * theme to re-render the cart drawer.
//  *
//  * How to trigger:
//  * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
//  *   bubbles: true
//  * }));
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 13) dispatch:cart-drawer:close
//  * -------------------------------------------------------------------------------------------------
//  * Closes the cart drawer.
//  *
//  * How to trigger:
//  * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 14) on:debounced-resize
//  * -------------------------------------------------------------------------------------------------
//  * Fires when the viewport finishes resizing (debounced to 300ms by default).
//  *
//  * How to listen:
//  * window.addEventListener('on:debounced-resize', (event) => {
//  *   // your code here
//  * });
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 15) on:breakpoint-change
//  * -------------------------------------------------------------------------------------------------
//  * Fires when the breakpoint of the viewport changes. See the 'Media Queries' section in this file
//  * for more.
//  *
//  * Example:
//  * window.addEventListener('on:breakpoint-change', (event) => {
//  *  if (theme.mediaMatches.md) {
//  *   console.log('we are not on mobile');
//  *  }
//  * });
//  *
//  *
//  *
//  * =================================================================================================
//  * Web Components
//  * =================================================================================================
//  *
//  * Canopy utilizes Web Components to the fullest.
//  *
//  * Web Components are a set of standardized APIs that allow developers to create custom, reusable
//  * HTML elements that can be used across different web pages and applications.
//  * Web Components consist of three main technologies: Custom Elements, Shadow DOM and HTML
//  * Templates.
//  *
//  * See Mozilla for more: https://developer.mozilla.org/en-US/docs/Web/Web_Components
//  *
//  *
//  *
//  * =================================================================================================
//  * Third-Party JavaScript Dependencies
//  * =================================================================================================
//  *
//  * Canopy only has one third-party dependency: instant.page (https://instant.page/).
//  *
//  * It's included locally and is only active if it has been enabled in
//  * 'Theme Settings > Advanced > Preload links on hover'.
//  *
//  * Instant.page is a JavaScript library that speeds up page loads by preloading links as soon as the
//  * customer hovers over them.
//  *
//  *
//  *
//  * =================================================================================================
//  * Code Splitting
//  * =================================================================================================
//  * We followed the 'code splitting' technique when building Canopy.
//  *
//  * Code splitting consists in writing JavaScript (and CSS)in a modularized way within typically
//  * small, more manageable files that can be loaded on-demand, as needed. The idea is to improve the
//  * performance of our theme by reducing the amount of code that needs to be loaded upfront.
//  *
//  * If the customer is visiting a specific page of the theme that requires certain JavaScript
//  * functionality, only the code needed for that page will be loaded, rather than one large
//  * JavaScript file containing largely unused code. For example, the file media-gallery.js will
//  * only be loaded if there is a media gallery on the page.
//  *
//  * Shopify uses HTTP/2, which is the newer version of the HTTP protocol used to deliver web content.
//  * HTTP/2 supports multiplexing, which means that multiple requests can be sent over a single
//  * connection at the same time - meaning multiple JS files are essentially served at the speed of a
//  * single file.
//  *
//  * The only JS file which is served on every page in Canopy is 'main.js'. Main.js contains
//  * utility JS which is likely to be needed by many scripts. This is outlined more in the next
//  * section.
//  *
//  *
//  *
//  * =================================================================================================
//  * Utilities
//  * =================================================================================================
//  * Canopy provides a few utility utilities, contained in main.js. Some of the key ones are
//  * outlined below. See main.js for more.
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 1) Lazy Loading
//  * -------------------------------------------------------------------------------------------------
//  * Lazy loading is a technique for delaying the loading of certain elements until they are needed,
//  * which can help improve page load times.
//  *
//  * We use three functions used for lazy loading images and scripts in our theme:
//  *
//  *  - setImageSources function - copies the data-src and data-srcset attributes of lazy loaded
//  *    images to their src and srcset attributes.
//  *  - initLazyImages function - uses the IntersectionObserver API to lazy load images when needed.
//  *  - initLazyScript function - only loads a script when a specific element is scrolled into view.
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 2) Cookies
//  * -------------------------------------------------------------------------------------------------
//  * Cookies are small pieces of data that can be stored on a user's computer. They can be useful for
//  * tracking user activity, remembering user preferences or other similar purposes.
//  *
//  * We use three functions to manage cookies:
//  *
//  *  - setCookie function - sets a cookie with a given name, value and number of days until it
//  *  should expire.
//  *  - getCookie function - takes in the name of a cookie to retrieve its value.
//  *  - deleteCookie function - takes in the name of a cookie to delete it.
//  *
//  *
//  * -------------------------------------------------------------------------------------------------
//  * 3) Media Queries
//  * -------------------------------------------------------------------------------------------------
//  * The theme creates a theme.mediaMatches object (in theme.liquid) for several key screen sizes
//  * specified in our theme, and adds listeners for each media query.
//  *
//  * These are:
//  *
//  * mediaQueries: {
//  *  sm: '(min-width: 600px)',
//  *  md: '(min-width: 769px)',
//  *  lg: '(min-width: 1024px)',
//  *  xl: '(min-width: 1280px)',
//  *  xxl: '(min-width: 1536px)',
//  *  portrait: '(orientation: portrait)'
//  * }
//  *
//  * If a breakpoint is crossed, the mediaMatches values are updated and an 'on:breakpoint-change'
//  * event is dispatched.
//  *
//  * You can request the entire theme.mediaMatches object to check which media queries are currently
//  * matched. In this case, the returned data will be an object with the names of the media queries as
//  * keys, and boolean values indicating whether they are currently matched or not.
//  *
//  * Example:
//  *
//  * {
//  *  sm: true,
//  *  md: true,
//  *  lg: true,
//  *  xl: true,
//  *  xxl: false,
//  *  portrait: false
//  * }
//  *
//  * You can reference a specific media query to check if it's currently matched by using:
//  * theme.mediaMatches.lg.
//  *
//  * To check if you're on mobile you can use:
//  * !theme.mediaMatches.md
//  *
//  * If you want to perform some action when the breakpoint changes, you can listen for the
//  * breakpoint-change event on the window object.
//  *
//  * Example:
//  * window.addEventListener('on:breakpoint-change', (event) => {
//  *  // your code here
//  * });
//  *
//  * =================================================================================================
//  *
//  * Have fun! - The Clean Canvas Development Team.
//  */

// Re-active Header checkout button after page loaded.
document.addEventListener('DOMContentLoaded', function(){
  const main_checkout_btn = document.querySelector('#cart-summary')?.querySelector('[name="checkout"]');
  if(main_checkout_btn){
    const header_checkout_btn = document.querySelector('.header_checkout')?.querySelector('button');
    if(header_checkout_btn){
      header_checkout_btn.addEventListener('click', ()=> main_checkout_btn.click());
    }
  }
})

/*

const searchForm = document.querySelector('.search-form.search-custom');
searchForm.addEventListener('submit', function (event) {
  event.preventDefault();
  waitForProductsToLoad().then(() => {
    searchFilter();
  });
});

const expectedProductCount = 200; // Set this to the total number of products in the collection

function waitForProductsToLoad() {
  return new Promise((resolve) => {
    const checkProductsLoaded = setInterval(() => {
      const allProductsLoaded = document.querySelectorAll('.main-products-grid__results .grid li').length >= expectedProductCount;
      if (allProductsLoaded) {
        clearInterval(checkProductsLoaded);
        resolve();
      }
    }, 100); // Check every 100ms
  });
}

function searchFilter() {
  const input = document.getElementById('filterSearchInput');
  const filter = input.value.toUpperCase();
  const ul = document.querySelector(".main-products-grid__results .grid");
  const li = ul.getElementsByTagName('li');
  const productToolbar = document.querySelector('.products-toolbar');

  let hasMatch = false;

  for (let i = 0; i < li.length; i++) {
    const a = li[i].querySelector(".card__title a.card-link");
    const txtValue = a.textContent || a.innerText;
    const productTitle = txtValue.toUpperCase().trim();

    if (productTitle.includes(filter)) {
      li[i].classList.remove('hidden');
      hasMatch = true;
    } else {
      li[i].classList.add('hidden');
    }
  }

  if (hasMatch) {
    productToolbar.classList.add('hidden');
  } else {
    productToolbar.classList.remove('hidden');
  }
}

*/

/*

function searchFilter() {
  // Declare variables
  var input, filter, ul, li, a, i, txtValue;
  input = document.getElementById('filterSearchInput');
  filter = input.value.toUpperCase();
  ul = document.querySelector(".main-products-grid__results .grid ");
  li = ul.getElementsByTagName('li');
  const productToolbar = document.querySelector('.products-toolbar')
  
  for (i = 0; i < li.length; i++) {
    a = li[i].getElementsByTagName("a")[0];
    txtValue = a.textContent || a.innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      li[i].classList.remove('hidden');
      productToolbar.classList.remove('hidden');
    } else {
      li[i].classList.add('hidden');
      productToolbar.classList.add('hidden');
    }
  }
}
*/


// Search functionality on Collection Page

// const searchForm = document.querySelector('.search-form.search-custom');
// const searchInput = document.querySelector('.search-custom .search__input');
// const collectionErrorMessage = document.querySelector('.error-message-container.hidden')
// const ProductGridcontainer = document.querySelector('.main-products-grid');
// const loadingMessage = document.querySelector('.collection-loading');
// const collectionToolbar = document.querySelector('.products-toolbar');
// const searchButton = document.querySelector('.search__submit-btn');
// if (searchInput != null) {
//  searchInput.addEventListener('input', function() {
//   if (searchInput.value.trim() !== '') {
//       searchButton.removeAttribute('disabled');
//       searchButton.classList.remove('disabled');
//     } else {
//       searchButton.setAttribute('disabled', 'true');
//       searchButton.classList.add('disabled');
//     }
//  }) 
// }

// if (searchForm != null) {
//  searchForm.addEventListener('submit', async function(event) {
//    console.log('On Form submit:', new Date());
//     event.preventDefault();
//     ProductGridcontainer.classList.add('hidden');
//     loadingMessage.classList.remove('hidden');
//     collectionToolbar.classList.add('hidden');
//     const searchValue = searchInput.value.trim(); 
//     if (searchValue) {
//       await SearchRenderProducts(searchValue, event);
//     }
//  }); 
// }

// async function SearchRenderProducts(value, evt){
//   const currentCollection = evt?.target?.closest('.collection-search')?.getAttribute('data-collection-handle');
//   if(currentCollection) await fetchFromTemp(value, currentCollection);
// }

// async function fetchFromTemp(value, collectionHandle) {
//   var matchedLi = [];
//   if(value != ''){
//     var fetchedResult = '';
//     for(let i=1; i <=2; i++){      
//       const content = await (await fetch(`/collections/${collectionHandle}?view=custom-searchbar&page=${i}`));
//       const response = await content.text();
//       const html = new DOMParser().parseFromString(response, 'text/html');
//       const getValuedLength = html?.querySelector('.main-products-grid__results')?.querySelectorAll('li');
//       if(getValuedLength.length > 0) fetchedResult = html?.querySelector('.main-products-grid__results');
//       if (getValuedLength.length > 0) {
//         Array.from(getValuedLength).forEach(val => {
//           const titleElement = val?.querySelector('.card__info-container .card__title a');
//           const title = titleElement?.innerText.trim();
//           if (title && title.toLowerCase().includes(value.toLowerCase())) {
//             matchedLi.push(val);
//           }
//         });
//       }
//     }
//     await reRenderCollection(matchedLi, fetchedResult);   
//   } else {
//     const content = await (await fetch(`/collections/${collectionHandle}`));
//     const response = await content.text();
//     const html = new DOMParser().parseFromString(response, 'text/html');
//     setTimeout(() => {
//       const productItems = document.querySelectorAll('.main-products-grid__results li .card__media img');
//       productItems.forEach(productItem => {
//         const cardMedia = productItem.getAttribute('data-srcset');
//         productItem.setAttribute('srcset', cardMedia);
//       }); 
//     }, 1000);
//     const productToolbar = document.querySelector('.products-toolbar');
//     productToolbar.classList.remove('hidden');
//     const getValuedLength = html?.querySelector('.main-products-grid__results');
//     document.querySelector('.main-products-grid__results').innerHTML = getValuedLength.innerHTML;
//     if(document.querySelector('.main-products-grid nav[aria-label="Pagination"]')){
//       const pagination = document.querySelector('.main-products-grid nav[aria-label="Pagination"]');
//       const paginationItems = html?.querySelector('.main-products-grid nav[aria-label="Pagination"]');
//       pagination.innerHTML = paginationItems.innerHTML;
//       document.dispatchEvent(new CustomEvent('on:bfcache:load-restore'))
//     }
//   } 
// }

// var filterSearch = document.querySelector('.collection-search #filterSearchInput');
// if(filterSearch != null) {
// filterSearch.addEventListener('input', async function (e) {
//   const value = e.target.value;
//   if (value.length <= 0) {
//     console.log('no value');
//     collectionErrorMessage.style.display = 'none';
//     ProductGridcontainer.classList.remove('hidden');
//     var collectionHandle = document.querySelector('.collection-search').dataset.collectionHandle;
//     fetchFromTemp(value, collectionHandle);
//     collectionToolbar.classList.remove('hidden');
//   } 
// });  
// }


// async function reRenderCollection(arr, result){
//   ProductGridcontainer.classList.remove('hidden');
//   loadingMessage.classList.add('hidden');
//   const productToolbar = document.querySelector('.products-toolbar');
//   productToolbar.classList.add('hidden');
//   const collectionGrid = document.querySelector('custom-pagination')?.querySelector('.main-products-grid__results');
//   const resultUl = result?.querySelector('ul');
//   resultUl.innerHTML = '';
//   arr.forEach((li)=>{
//     const mediaSrcset = li.querySelector('.card__media')?.querySelector('img')?.getAttribute('data-srcset');
//     if (li.querySelector('.card__media img')) {
//       li.querySelector('.card__media img').setAttribute('srcset', mediaSrcset);
//     }
//     const liOuterHTML = li.outerHTML;
//     resultUl.insertAdjacentHTML("beforeend", liOuterHTML);
//   });
//   collectionGrid.innerHTML = resultUl.outerHTML;
//   if (resultUl.innerHTML.length <= 0) {
//     collectionErrorMessage.style.display = 'flex';
//   } else {
//     collectionErrorMessage.style.display = 'none';
//   }
//   // const pagination = document.querySelector('.main-products-grid nav[aria-label="Pagination"]');
//   // const paginationItems = html?.querySelector('.main-products-grid nav[aria-label="Pagination"]');
//   // pagination.innerHTML = paginationItems.innerHTML;
//   console.log('Results shown at:',new Date());
// }


const searchForm = document.querySelector('.search-form.search-custom');
const searchInput = document.querySelector('.search-custom .search__input');
const collectionErrorMessage = document.querySelector('.error-message-container.hidden')
const ProductGridcontainer = document.querySelector('.main-products-grid');
const loadingMessage = document.querySelector('.collection-loading');
const collectionToolbar = document.querySelector('.products-toolbar');
const searchButton = document.querySelector('.search__submit-btn');
if (searchInput != null) {
 searchInput.addEventListener('input', function() {
  if (searchInput.value.trim() !== '') {
      searchButton.removeAttribute('disabled');
      searchButton.classList.remove('disabled');
    } else {
      searchButton.setAttribute('disabled', 'true');
      searchButton.classList.add('disabled');
    }
 }) 
}

if (searchForm != null) {
 searchForm.addEventListener('submit', async function(event) {
   console.log('On Form submit:', new Date());
    event.preventDefault();
    ProductGridcontainer.classList.add('hidden');
    loadingMessage.classList.remove('hidden');
    collectionToolbar.classList.add('hidden');
    const searchValue = encodeURIComponent(searchInput.value.trim().replace(/\s+/g, '+'));
    const searchUrl = `https://freshfood2u.co/search?options[prefix]=last&q=${searchValue}&filter.p.product_type=`;
    if (searchValue && searchValue.length >= 2) {
      await SearchRenderProducts(searchValue, event);
      await searchAndFilterCollection(searchInput.value);
    }
 }); 
}

async function SearchRenderProducts(value, evt){
  const currentCollection = evt?.target?.closest('.collection-search')?.getAttribute('data-collection-handle');
  if(currentCollection) await fetchFromTemp(value, currentCollection);
}

const searchCache = new Map(); // Cache for storing search results

async function fetchFromTemp(value, collectionHandle) {
  if (value === '') {
    const content = await fetch(`/collections/${collectionHandle}`);
    const response = await content.text();
    const html = new DOMParser().parseFromString(response, 'text/html');
    
    const productToolbar = document.querySelector('.products-toolbar');
    productToolbar.classList.remove('hidden');
    
    const getValuedLength = html?.querySelector('.main-products-grid__results');
    document.querySelector('.main-products-grid__results').innerHTML = getValuedLength.innerHTML;

    requestAnimationFrame(() => {
      document.querySelectorAll('.main-products-grid__results li .card__media img').forEach(img => {
        const cardMedia = img.getAttribute('data-srcset');
        if (cardMedia) img.setAttribute('srcset', cardMedia);
      });
    });

    const pagination = document.querySelector('.main-products-grid nav[aria-label="Pagination"]');
    if (pagination) {
      const paginationItems = html?.querySelector('.main-products-grid nav[aria-label="Pagination"]');
      pagination.innerHTML = paginationItems.innerHTML;
      document.dispatchEvent(new CustomEvent('on:bfcache:load-restore'));
    }
    return;
  }

  const cacheKey = `${collectionHandle}-${value.toLowerCase()}`;
  if (searchCache.has(cacheKey)) {
    console.log('Serving results from cache');
    const cachedData = searchCache.get(cacheKey);
    await reRenderCollection(cachedData.matchedLi, cachedData.firstValidResult);
    return;
  }

  const pages = [1, 2, 3, 4, 5];
  const fetchPromises = pages.map(page => 
    fetch(`/collections/${collectionHandle}?view=custom-searchbar&page=${page}`)
      .then(resp => resp.text())
  );

  const responses = await Promise.all(fetchPromises);
  const matchedLi = [];
  let firstValidResult = null;

  responses.forEach(response => {
    const html = new DOMParser().parseFromString(response, 'text/html');
    const results = html?.querySelector('.main-products-grid__results');
    const items = results?.querySelectorAll('li'); 
    
    if (items?.length) {
      if (!firstValidResult) firstValidResult = results;
      items.forEach(val => {
        const titleElement = val?.querySelector('.card__info-container .card__title a');
        var title = titleElement?.innerText?.trim()?.toLowerCase();
        var reverse_title = title.split(' ');
        var new_updated_reverse_title = reverse_title.reverse().join(' ');
    
        const searchKeywords = value.toLowerCase().trim().split(/\s+/);

        const titleMatches = searchKeywords.some(keyword =>{
          if(title.includes(keyword)){
            return true;
          }
          return false;
        });
        
        const reverseTitleMatches = searchKeywords.some(keyword =>{
          if(new_updated_reverse_title.includes(keyword)){
            return true;
          }
          return false;
        });
    
        if(titleMatches || reverseTitleMatches) {
          matchedLi.push(val.cloneNode(true)); // Clone before caching
        } else {
          title = val?.getAttribute('data-sku')?.trim()?.toLowerCase();
          if(title?.includes(value.toLowerCase())) {
            matchedLi.push(val.cloneNode(true)); // Clone before caching
          }
        }
      });
    }
  });

  searchCache.set(cacheKey, {
    matchedLi: matchedLi.map(li => li.cloneNode(true)), // Store cloned nodes
    firstValidResult: firstValidResult?.cloneNode(true)
  });

  await reRenderCollection(matchedLi, firstValidResult);
}

var filterSearch = document.querySelector('.collection-search #filterSearchInput');
if(filterSearch != null) {
  filterSearch.addEventListener('input', function (e) {
    const value = e.target.value;
    const collectionCount = document.querySelector('[data-num-results]').getAttribute('data-num-results');
    const countInner = document.querySelector('.collection-count');
    if (value.length <= 0) {
      console.log('no value');
      countInner.textContent = collectionCount; 
      collectionErrorMessage.style.display = 'none';
      var collectionHandle = document.querySelector('.collection-search').dataset.collectionHandle;
      fetchFromTemp(value, collectionHandle);
      collectionToolbar.classList.remove('hidden');
      ProductGridcontainer.classList.remove('hidden');
    }
  });
}

async function reRenderCollection(arr, result){
  ProductGridcontainer.classList.remove('hidden');
  loadingMessage.classList.add('hidden');
  const productToolbar = document.querySelector('.products-toolbar');
  productToolbar.classList.add('hidden');
  const collectionGrid = document.querySelector('custom-pagination')?.querySelector('.main-products-grid__results');
  const resultUl = result?.querySelector('ul');
  resultUl.innerHTML = '';
  const fragment = document.createDocumentFragment();
  const ul = document.createElement('ul');
  ul.className = resultUl?.className || '';
  
  arr.forEach((li)=>{
    const clone = li.cloneNode(true);
    const img = clone.querySelector('.card__media img');
    if (img) {
      const mediaSrcset = img.getAttribute('data-srcset');
      if (mediaSrcset) img.setAttribute('srcset', mediaSrcset);
    }
    ul.appendChild(clone);
  });
  
  fragment.appendChild(ul);
  collectionGrid.innerHTML = '';
  collectionGrid.appendChild(fragment);

  collectionErrorMessage.style.display = arr.length ? 'none' : 'flex';
  console.log('Results shown at:',new Date());
}

document.addEventListener('DOMContentLoaded', function(){
  window.addEventListener('beforeunload', () => {
    searchCache.clear();
  });

  setInterval(() => {
    searchCache.clear();
  }, 5 * 60 * 1000);
});



document.addEventListener('DOMContentLoaded', function(){ 
  const mainProductPrice = document.querySelector('.product-info__price .price');
  const priceElement = document.querySelector('.product-info__price');
  const messageContent = mainProductPrice?.getAttribute('data-message')
  console.log('sa')
  
  function showMessage(priceText) {
      const priceWithoutSymbol = priceText?.replace('£', '').trim();
      if (priceWithoutSymbol === '0.01' || priceWithoutSymbol === '0.00') {
        
          mainProductPrice.innerHTML = messageContent;
      }
  }
  const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
              const updatedPrice = mainProductPrice.innerText;
              showMessage(updatedPrice);
              if (typeof BSS_B2B == 'object') {
                 BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
              }
          }
      });
  });
  
  const config = { childList: true, characterData: true, subtree: true };
  if(priceElement) observer.observe(priceElement, config);
  
  const initialPrice = mainProductPrice?.innerText;
  showMessage(initialPrice);
});

// update delivery date with custom js
async function setCookie(name, value, hours) {
  let expires = '';

  if (hours) {
    const date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
async function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    const value = cookies.pop().split(';').shift();
    return decodeURIComponent(value);
  }

  return null;
}


async function updateDeliveryDate() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
              attachDeliveryDateListener();
          }
      });
  });

  observer.observe(cartDrawer, {
      childList: true,
      subtree: true
  });

  async function attachDeliveryDateListener() {
      const delivery_date_container = document.querySelectorAll('.delivery_date_container');
      if (delivery_date_container.length > 0) {
          for (const delivery_container of delivery_date_container) {
              const cart_drawer_note = document.querySelector('cart-drawer')?.querySelector('form')?.querySelector('#cart-note');
              const delivery_input = delivery_container?.querySelector('input[type="date"]');

              const existed_default_date = await getCookie('only_delivery_date');
            
              if (delivery_input && cart_drawer_note) {
                  const closest_cart_summary = delivery_container?.closest('.cart-drawer__summary');
                  const drawer_checkout_container = closest_cart_summary.querySelector('.cart-drawer__checkout-buttons');
                  const drawer_checkout_button = closest_cart_summary.querySelector('.js-cart-custom-link');
                if(delivery_input.value.length > 0 && drawer_checkout_button.classList.contains('additional-requirement_met')){
                  if(drawer_checkout_button.classList.contains('js_cart_delivery_date_error') && drawer_checkout_button.hasAttribute('disabled')){
                    drawer_checkout_button.classList.remove('js_cart_delivery_date_error'); 
                    drawer_checkout_button.removeAttribute('disabled');
                    if(drawer_checkout_container.classList.contains('js_additional_checkout_button'))drawer_checkout_container.classList.remove('js_additional_checkout_button'); 
                  }
                } else{
                  if(drawer_checkout_button){
                    drawer_checkout_button.classList.add('js_cart_delivery_date_error'); 
                    drawer_checkout_button.setAttribute('disabled', true); 
                    drawer_checkout_container.classList.add('js_additional_checkout_button'); 
                    if(drawer_checkout_container) window.showDeliveryErrorPrompt(drawer_checkout_container, closest_cart_summary);
                  }
                }

                  const onload_note_message = window.theme.strings.delivery_date_text.text;
                  const onload_noteText = onload_note_message.replace('[date]', delivery_input.value);
                  const deliveryDateFromSession = await getCookie('updated_delivery_date');
                  if(deliveryDateFromSession != null){
                    await setCookie('updated_delivery_date', deliveryDateFromSession, 1);
                  }else{
                    await setCookie('delivery_date', onload_noteText, 1);
                  }
                  if(existed_default_date != null){
                    await setCookie('only_delivery_date', existed_default_date, 1);
                    delivery_input.value = existed_default_date;
                  }else{
                    await setCookie('only_delivery_date', delivery_input.value, 1);
                  }
                
                delivery_input.removeEventListener('change', handleDeliveryDateChange);
                delivery_input.addEventListener('change', handleDeliveryDateChange);
              }
          }
      }
  }

  async function handleDeliveryDateChange(event) {
      const delivery_input = event.target;
      const cart_drawer_note = document.querySelector('cart-drawer')?.querySelector('form')?.querySelector('#cart-note');

      const closest_cart_summary = delivery_input?.closest('.cart-drawer__summary');
      const drawer_checkout_container = closest_cart_summary.querySelector('.cart-drawer__checkout-buttons');
      const drawer_checkout_button = closest_cart_summary.querySelector('.js-cart-custom-link');
    
      const delivery_date_value = delivery_input.value;
      if(delivery_date_value.length > 0 && drawer_checkout_button.classList.contains('additional-requirement_met')){        
        closest_cart_summary.querySelector('.js-delivery-date-error').classList.remove('js_cart_delivery_date_error');         
        if(drawer_checkout_button.classList.contains('js_cart_delivery_date_error') && drawer_checkout_button.hasAttribute('disabled')){
          drawer_checkout_button.classList.remove('js_cart_delivery_date_error'); 
          drawer_checkout_button.removeAttribute('disabled');
          if(drawer_checkout_container.classList.contains('js_additional_checkout_button')) drawer_checkout_container.classList.remove('js_additional_checkout_button'); 
        }
      } else{
        if(drawer_checkout_button){
          drawer_checkout_button.classList.add('js_cart_delivery_date_error'); 
          drawer_checkout_button.setAttribute('disabled', '');
          drawer_checkout_container.classList.add('js_additional_checkout_button'); 
          if(drawer_checkout_container) window.showDeliveryErrorPrompt(drawer_checkout_container, closest_cart_summary);
        }
      }
        const note_message = window.theme.strings.delivery_date_text.text;
        const noteText = note_message.replace('[date]', delivery_date_value);
        cart_drawer_note.value = noteText;
        await setCookie('delivery_date', noteText, 1);
        await setCookie('updated_delivery_date', noteText, 1);
        await setCookie('only_delivery_date', delivery_date_value, 1);
  }

  attachDeliveryDateListener();
}

window.showDeliveryErrorPrompt = function (element, cart_container){
  if(element){
    element.addEventListener('click',()=>{
      const drawer_checkout_button = cart_container.querySelector('.js-cart-custom-link');
      if(!drawer_checkout_button.classList.contains('additional-requirement_met')) return;
      if(!element.classList.contains('js_additional_checkout_button')) return;
      const delivery_error_ele = cart_container?.querySelector('.js-delivery-date-error');
      if(delivery_error_ele){
        delivery_error_ele.classList.remove('hidden');
        setTimeout(()=>{
          delivery_error_ele.classList.add('hidden');
        }, 1500);
      }
    })
  }
}
document.addEventListener("DOMContentLoaded", updateDeliveryDate);

const header = document.querySelector('.header');
const stickyClass = 'has_stickyHeader';

window.addEventListener('scroll', () => {
  if (window.scrollY > 50) {
    header.classList.add(stickyClass);
  } else {
    header.classList.remove(stickyClass);
  }
});


//============  Updated code for the search bar on the collection page ============ //

async function searchAndFilterCollection(value) {
  const searchValue = value.trim().replace(/\s+/g, '+');
  const currentCollectionHandle = document.querySelector('.collection-search')?.dataset.collectionHandle;
  const grid = document.querySelector('.main-products-grid__results ul');

  collectionErrorMessage.style.display = 'none';
  loadingMessage.style.display = 'flex';
  ProductGridcontainer.classList.add('hidden');

  grid.innerHTML = '';
  const searchUrl = `/search?options[prefix]=last&q=${searchValue}&filter.p.product_type=`;
  const response = await fetch(searchUrl);
  const text = await response.text();
  const doc = new DOMParser().parseFromString(text, 'text/html');
  const allLis = Array.from(doc.querySelectorAll(`li[data-collection-handle="${currentCollectionHandle}"]`));
  const itemCount = allLis.length;
  const collectionCount = document.querySelector('.collection-count');
  collectionCount.textContent = itemCount;
  allLis.forEach(li => grid.appendChild(li));

  grid.querySelectorAll('img').forEach(img => {
    if (img.hasAttribute('data-src') && !img.src) {
      img.src = img.getAttribute('data-src');
    }
    if (img.hasAttribute('data-srcset') && !img.srcset) {
      img.srcset = img.getAttribute('data-srcset');
    }
  });

  loadingMessage.style.display = 'none';
  ProductGridcontainer.classList.remove('hidden');

  if (allLis.length === 0) {
    collectionErrorMessage.style.display = 'flex';
  } else {
    collectionErrorMessage.style.display = 'none';
  }
}


//// checkout 
document.addEventListener('DOMContentLoaded', function () {
  const checkoutButton = document.querySelector('.btn-cart-checkout');
  const netTermButton = document.getElementById('bss-b2b-net-term-button');

  if (checkoutButton && netTermButton) {
    checkoutButton.addEventListener('click', function (e) {
      e.preventDefault(); 
      e.stopPropagation(); 
      
      netTermButton.click();
    });
  }
});


